/**
 * shop-load-more.js — nút "Xem thêm sản phẩm" dưới lưới Cửa hàng (mục 33) + skeleton
 * đang tải (mục 20).
 *
 * Markup cần:
 *   [data-filter-grid][data-total] > .product-card…
 *   .load-more[data-load-more] > [data-load-more-count] + .load-more__bar[role=progressbar] > span (--pct)
 *                              + button[data-load-more-button]
 *
 * Bản tĩnh không có trang 2: bấm nút thì chèn đủ một hàng skeleton, chờ một nhịp rồi nhân
 * bản lô card đầu tiên làm "trang tiếp theo" — đủ để xem nhịp tải, thanh tiến độ và số đếm
 * chạy. Card nhân bản giữ nguyên data-product-id nên nút "Thêm" / yêu thích vẫn chạy (cart.js,
 * wishlist.js bắt sự kiện ở document). Xong thì phát `wb:shop-grid` để filters.js đánh số,
 * sắp xếp và đếm lại.
 *
 * Focus chuyển vào card đầu tiên vừa nạp: người dùng bàn phím đi tiếp từ đó thay vì phải
 * Tab lại qua cả lưới cũ.
 *
 * WP: nút là <a href="<?php echo esc_url( next_posts_link URL ); ?>"> để chạy cả khi không có
 * JS; bản thật chặn link, tải trang kế bằng fetch() rồi lấy các .product-card trong
 * .products của HTML trả về chèn vào — thay hàm nextPage() bên dưới, phần còn lại giữ nguyên.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var DELAY = 900;

    function all(selector, scope) {
        return [].slice.call((scope || document).querySelectorAll(selector));
    }

    function emit(name) {
        var event;
        try {
            event = new CustomEvent(name);
        } catch (e) {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(name, false, false, null);
        }
        document.dispatchEvent(event);
    }

    // Khung skeleton giống card (guideline mục 20): ảnh 200px + 3 dòng + giá / nút
    function skeleton() {
        var el = document.createElement('div');
        el.className = 'skeleton-card shop-skeleton';
        el.setAttribute('aria-hidden', 'true');
        el.innerHTML =
            '<span class="skeleton skeleton--soft skeleton-card__media"></span>' +
            '<div class="skeleton-card__body">' +
            '<span class="skeleton skeleton--soft shop-skeleton__line shop-skeleton__line--meta"></span>' +
            '<span class="skeleton shop-skeleton__line shop-skeleton__line--title"></span>' +
            '<span class="skeleton shop-skeleton__line shop-skeleton__line--short"></span>' +
            '<div class="shop-skeleton__foot"><span class="skeleton shop-skeleton__price"></span>' +
            '<span class="skeleton skeleton--soft shop-skeleton__btn"></span></div>' +
            '</div>';
        return el;
    }

    function init() {
        var box = document.querySelector('[data-load-more]');
        var grid = document.querySelector('[data-filter-grid]');
        if (!box || !grid) return;

        var button = box.querySelector('[data-load-more-button]');
        var countEl = box.querySelector('[data-load-more-count]');
        var bar = box.querySelector('[role="progressbar"]');
        var fill = bar ? bar.querySelector('span') : null;
        var total = parseInt(grid.getAttribute('data-total'), 10) || 0;
        var perPage = all('.product-card', grid).length;
        var busy = false;

        if (!button || !perPage) return;

        function render() {
            var seen = all('.product-card', grid).length;
            if (countEl) countEl.textContent = 'Đã xem ' + seen + ' / ' + total + ' sản phẩm';
            if (bar) bar.setAttribute('aria-valuenow', String(seen));
            if (fill) fill.style.setProperty('--pct', Math.min(100, (seen / total) * 100).toFixed(2) + '%');
            button.hidden = seen >= total;
        }

        // Một "trang" = lô card đầu tiên theo thứ tự gốc (data-shop-index do filters.js đánh)
        function nextPage() {
            var originals = all('.product-card', grid).filter(function (card) {
                return Number(card.getAttribute('data-shop-index')) < perPage;
            });
            originals.sort(function (a, b) {
                return Number(a.getAttribute('data-shop-index')) - Number(b.getAttribute('data-shop-index'));
            });
            return originals.map(function (card) {
                var copy = card.cloneNode(true);
                copy.removeAttribute('data-shop-index');
                copy.hidden = false;
                return copy;
            });
        }

        // Đủ lấp một hàng của lưới hiện tại (2 cột mobile, 3 cột desktop…)
        function columns() {
            var template = window.getComputedStyle(grid).gridTemplateColumns || '';
            return Math.max(1, template.split(' ').filter(Boolean).length);
        }

        button.addEventListener('click', function () {
            if (busy) return;
            busy = true;
            button.classList.add('is-loading');
            button.disabled = true;
            button.setAttribute('aria-busy', 'true');

            var placeholders = [];
            for (var i = 0; i < columns(); i++) {
                placeholders.push(grid.appendChild(skeleton()));
            }

            window.setTimeout(function () {
                placeholders.forEach(function (el) {
                    grid.removeChild(el);
                });
                var fresh = nextPage().slice(0, Math.max(0, total - all('.product-card', grid).length));
                fresh.forEach(function (card) {
                    grid.appendChild(card);
                });

                busy = false;
                button.classList.remove('is-loading');
                button.disabled = false;
                button.removeAttribute('aria-busy');

                emit('wb:shop-grid');
                render();

                var link = fresh.length ? fresh[0].querySelector('.product-card__title a') : null;
                if (link) link.focus();
            }, DELAY);
        });

        render();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
